import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteDesignationSlice = createSlice({
  name: 'DeleteDesignation',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteDesignation: (state, _) => {
      state.isLoading = true;
    },
    successDeleteDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteDesignation: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteDesignation,
  failureDeleteDesignation,
  successDeleteDesignation,
  clearDeleteDesignation,
} = DeleteDesignationSlice.actions;

export default DeleteDesignationSlice.reducer;
